import { BroadcastDeviceBanner } from '@magnetar/data-access'
import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { useGet } from './useFetch'
import { useAuth } from './useAuth'

export function useBroadcastDeviceBanners(broadcastDeviceId: string | undefined) {
  const { token } = useAuth()
  const { data, error, mutate, isLoading } = useGet<ApiResponse<BroadcastDeviceBanner[]>>(
    token && broadcastDeviceId ? `/api/broadcast-device/${broadcastDeviceId}/banner` : null,
    undefined,
    token ?? '',
  )

  return {
    banners: data?.data || [],
    isLoading,
    isError: error,
    mutate,
  }
}
